// Styles
import './styles.scss';
// Core
import React, { useState } from 'react';
import {
    GeckoAlert,
    GeckoBtn,
    GECKO_CONSTS,
    GeckoFields,
} from '@geckolabs/gecko-react-ui';
// Services
import RsvpService from '../../../../services/RsvpService';
import PostMessageToRnWebview from '../../../../services/PostMessageToRnWebview';

const makeGuestCountFieldOptions = (maxNumberOfGuests) => {
    const array = [...Array(maxNumberOfGuests ? maxNumberOfGuests + 1 : 1).keys()];

    const options = array.map(item => {
        return {
            label: item === 0 ? '0' : item.toString(),
            value: item,
        }
    });
    return options;
};

export const ManageGuestCount = ({ event, eventAttendance }) => {
    const [maxNumberOfGuests, setMaxNumberOfGuests] = useState(event.maximum_guests);
    const [attendance, setAttendance] = useState(eventAttendance[0]);
    // The attendances_count includes the attendee so 1 needs to be subtracted
    const [savedGuestCount, setSavedGuestCount] = useState(attendance.attendances_count -1);
    const [values, setValues] = useState({guestCount: savedGuestCount});
    const [errorMessage, setErrorMessage] = useState(null);

    const changeGuestCount = () => {
        // Reset the state to remove the error alert
        setErrorMessage(null);
        
        const guestCount   = values.guestCount;
        const shouldUpdate = guestCount !== savedGuestCount;

        let promise;

        if (shouldUpdate) {
            promise = new RsvpService().changeGuests(attendance.id, guestCount).then(response => {
                setSavedGuestCount(guestCount);
                return PostMessageToRnWebview({
                    type: 'update',
                    reason: 'manual',
                    changes: { guestCount }
                });
            }).catch(error => setErrorMessage(error));
        } else {
            promise = Promise.resolve();
        }
        return promise;
    };  

    if (!maxNumberOfGuests) {
        return (
            <GeckoAlert type="warning" icon="exclamation-circle">
                Guests are not enabled for this event.
            </GeckoAlert>
        );
    }

    // Disable the button if the user doesn't select a new guest count value
    const disableButton = () => values.guestCount === savedGuestCount ? true : false;

    return (
        <div className='manage-guests-container'>
           {errorMessage ? (
                <GeckoAlert type="warning" icon="exclamation-circle" >
                    {errorMessage}
                </GeckoAlert>
            ) : null}

            <GeckoFields
                fields={[
                    {
                        key: 'guestCount',
                        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
                        options: makeGuestCountFieldOptions(maxNumberOfGuests),
                        width: '100%',
                        label: '',
                        config: {
                            clearable: false
                        }
                    }
                ]}
                values={values}
                handler={(key, value) => setValues({ [key]: value || 0 })}
            />
            <div className='button-container'>
                <GeckoBtn
                    name="Update Guests"
                    id="manage-guests"
                    type={GECKO_CONSTS.BTN_TYPE_SUCCESS}
                    size="sm"
                    icon="fa-users"
                    handler={() => changeGuestCount()}
                    disabledWhen={disableButton}
                />
            </div>
        </div>
    );
};

export default ManageGuestCount;